/**
 * Tier B — Frontend keyword-based sentiment scoring.
 * Returns: 'POSITIVE' | 'NEGATIVE' | 'NEUTRAL' | 'CAUTIONARY' | 'MIXED'
 */
const POSITIVE_WORDS = [
  'acquisition', 'partnership', 'growth', 'revenue', 'profit', 'expansion',
  'launch', 'funding', 'investment', 'raised', 'milestone', 'record', 'award',
  'deal', 'agreement', 'approved', 'upgraded', 'promotion', 'beat', 'exceeded',
  'surpassed',
];

const NEGATIVE_WORDS = [
  'lawsuit', 'layoff', 'layoffs', 'fine', 'breach', 'recall', 'fraud',
  'investigation', 'loss', 'decline', 'dropped', 'penalty', 'warning',
  'downgrade', 'shutdown', 'crisis', 'failure', 'bankruptcy', 'arrested',
  'charged', 'sued', 'violated', 'hack', 'leak', 'miss', 'missed',
];

export function getSentiment(text) {
  const t = (text || '').toLowerCase();

  // Special overrides — must check before scoring
  const hasMergerAcq = t.includes('merger') || t.includes('acquisition');
  const hasRegulatoryIssue = t.includes('antitrust') || t.includes('regulatory') || t.includes('investigation');
  if (hasMergerAcq && hasRegulatoryIssue) return 'MIXED';

  const hasWarningSignal = t.includes('warning') || t.includes('risk') || t.includes('caution') || t.includes('concern');
  const hasStrongPositive = POSITIVE_WORDS.some(w => t.includes(w));
  if (hasWarningSignal && !hasStrongPositive) return 'CAUTIONARY';

  // Keyword scoring
  let score = 0;
  POSITIVE_WORDS.forEach(w => { if (t.includes(w)) score += 1; });
  NEGATIVE_WORDS.forEach(w => { if (t.includes(w)) score -= 1; });

  if (score > 0) return 'POSITIVE';
  if (score < 0) return 'NEGATIVE';
  return 'NEUTRAL';
}

/**
 * Simplifies raw 5-value sentiment to 3 values: POSITIVE, NEGATIVE, NEUTRAL.
 * CAUTIONARY and MIXED map to NEUTRAL.
 */
export function getSimplifiedSentiment(rawSentiment) {
  if (rawSentiment === "POSITIVE") return "POSITIVE";
  if (rawSentiment === "NEGATIVE") return "NEGATIVE";
  return "NEUTRAL";
}
